<template>
  <div class="form-date">
    <v-menu
      v-model="showCalendar"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="value"
          required
          readonly
          v-on="on"
          outlined
          rounded
          dense
        />
      </template>
      <v-date-picker
        @input="changeDate"
        :weekday-format="getDay"
        :month-format="getMonthFormat"
        :header-date-format="getHeaderDateFormat"
        no-title
        first-day-of-week="1"
      />
    </v-menu>
  </div>
</template>
<script>
  import mixin from '@/plugins/mixin/mixin'
  export default {
    name: 'BaseDate',
    mixins: [mixin],

    props: {
      value: {
        type: String,
        default: ''
      }
    },

    data () {
      return {
        showCalendar: false,
        date: ''
      }
    },

    methods: {
      changeDate (event) {
        this.showCalendar = !this.showCalendar
        this.date = event
        this.$emit('input', this.date)
      }
    }
  }
</script>
